export function notEmpty<TValue>(value: TValue | null | undefined): value is TValue {
  return value !== null && value !== undefined;
}

export function getTime(date?: Date | string | number): number {
  if (date === null || date === undefined) {
    return 0;
  }
  if (date instanceof Date) {
    return date.getTime();
  } else {
    const newDate = new Date(date);
    if (isNaN(newDate.getTime())) {
      return 0;
    } else {
      return newDate.getTime();
    }
  }
}

export type SelectValue<T> = T | { value: T } | Array<T | { value: T }> | null | undefined;

export function toArrayOfValues<T>(input: SelectValue<T>): T[] {
  if (input == null) return [];

  const arr = Array.isArray(input) ? input : [input];

  return arr
    .map(item => (typeof item === 'object' && item !== null && 'value' in item ? (item as any).value : item))
    .filter((v): v is T => v != null);
}

export function startOfDayUtc(d: Date): Date {
  const x = new Date(d);
  x.setUTCHours(0, 0, 0, 0);
  return x;
}

export function endOfDayUtc(d: Date): Date {
  const x = new Date(d);
  x.setUTCHours(23, 59, 59, 999);
  return x;
}
